import { Dispatch } from "common/types";

import { signOut as signOutFirebase } from "services/firebase/auth";
import { unsubscribeFromPushNotifications } from "services/firebase/messaging/unsubscribeFromPushNotifications";
import { clearCache } from "services/queryClient";

import {
  signOut as signOutAction,
  signOutError,
  signOutStart
} from "seneca-common/features/user/state";
import { analyticsLogSignOut } from "seneca-common/utils/senecaAnalytics";
import logError from "seneca-common/utils/sentry/logError";

import { getRegionFromSessionStorageOrIpAndCache } from "features/regions/selectors";
import { clearHasSkippedCompleteTeacherAccount } from "features/teachers/pages/complete-teacher-account/utils/skippedCompleteTeacherAccount";

import { signInAsGuest } from "./utils";

export function signOut() {
  return async function (dispatch: Dispatch) {
    try {
      dispatch(signOutStart());

      await unsubscribeFromPushNotifications();
      await signOutFirebase();

      analyticsLogSignOut();
    } catch (error: any) {
      logError(error);
      dispatch(signOutError());
    }

    dispatch(signOutAction());
    clearCache();
    const region = await getRegionFromSessionStorageOrIpAndCache();
    clearHasSkippedCompleteTeacherAccount();
    dispatch(signInAsGuest(region));
  };
}
